import { teachRouteWhiteList } from '@/config/routes';
import { useTeachUserStore, useUserStore } from '@/stores';
import { computed } from 'vue';
import type { RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import type { EnhancedRouteLocation } from './types';
import { useRouteCacheStore } from '@/stores/routeCache';
import { useAuthStore } from '@/stores/auth';
import { isIOS } from 'vant/lib/utils';
import { showDialog } from 'vant';

// 是否是教练端
const teach = import.meta.env.VITE_APP_MODE === 'teach';

// 个人中心组件
const Profile = teach ? () => import('@/views/my/teach.vue') : () => import('@/views/my/index.vue');
// 订单详情组件
const OrderDetail = teach
  ? () => import('@/views/orders/teachOrderDetail.vue')
  : () => import('@/views/orders/userOrderDetail.vue');
// 登录页面
const Login = teach ? () => import('@/views/login/teachLogin.vue') : () => import('@/views/login/index.vue');
// 选择地址
const AddressSetting = teach
  ? () => import('@/views/address/addressSetting.vue')
  : () => import('@/views/address/addressSelect.vue');
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    // 如果是助教,重定向到订单这一页
    redirect: teach ? '/orders' : '/home',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录',
    },
  },
  {
    path: '/login-register',
    name: 'LoginRegister',
    component: () => import('@/views/login/teachIndex.vue'),
    meta: {
      title: '登录注册',
    },
  },
  // 和邀请页面整合一起
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('@/views/login/teachRegister.vue'),
  //   meta: {
  //     title: '注册',
  //   },
  // },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '心缘助教',
      keepAlive: true,
    },
  },
  {
    path: '/coach-detail',
    name: 'CoachDetail',
    component: () => import('@/views/coach/coachDetail.vue'),
    meta: {
      title: '助教详情',
    },
  },
  {
    path: '/booking',
    name: 'Booking',
    component: () => import('@/views/booking/index.vue'),
    meta: {
      title: '预约助教',
    },
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('@/views/orders/index.vue'),
    meta: {
      title: '订单',
      keepAlive: true,
    },
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/renew-order',
    name: 'RenewOrder',
    component: () => import('@/views/orders/RenewOrder.vue'),
    meta: {
      title: '续单',
    },
  },
  {
    path: '/address-select',
    name: 'address-select',
    component: AddressSetting,
    meta: {
      title: '选择地址',
    },
  },
  // {
  //   path: '/address/addressSetting',
  //   name: 'AddressSetting',
  //   component: () => import('@/views/address/addressSetting.vue'),
  //   meta: {
  //     title: '地址设置',
  //   },
  // },
  // {
  //   path: '/address/add',
  //   name: 'AddressAdd',
  //   component: () => import('@/views/address/addressEdit.vue'),
  //   meta: {
  //     title: '添加新地址',
  //   },
  // },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      title: '我的',
    },
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/views/my/withdraw.vue'),
    meta: {
      title: '提现',
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/my/settings.vue'),
    meta: {
      title: '个人信息设置',
    },
  },
  {
    path: '/invite',
    name: 'Invite',
    component: () => import('@/views/my/invite.vue'),
    meta: {
      title: '助教申请',
    },
  },
  {
    path: '/collect',
    name: 'Collect',
    component: () => import('@/views/my/collectList.vue'),
    meta: {
      title: '我的收藏',
    },
  },
  {
    path: '/protocol',
    name: 'Protocol',
    component: () => import('@/views/my/protocol.vue'),
    meta: {
      title: '用户协议',
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/my/privacy.vue'),
    meta: {
      title: '隐私协议',
    },
  },
  {
    path: '/empty',
    name: 'Empty',
    meta: { title: '缺省页' },
    component: () => import('@/views/empty.vue'),
  },
  {
    path: '/under-review',
    name: 'UnderReview',
    component: () => import('@/views/my/underReview.vue'),
    meta: {
      title: '助教审核',
    },
  },
  {
    path: '/promo',
    name: 'PromoBuzzcat',
    component: () => import('@/views/promo/buzzcat/index.vue'),
    meta: {
      title: '心缘助教x浅醺猫',
    },
  },
  {
    path: '/promo/cuebuddy',
    name: 'PromoCuebuddy',
    component: () => import('@/views/promo/buzzcat/cuebuddy.vue'),
    meta: {
      title: '微醺球局',
    },
  },

  {
    path: '/promo/wine',
    name: 'PromoWine',
    component: () => import('@/views/promo/buzzcat/wine.vue'),
    meta: {
      title: '微醺之夜',
    },
  },
  {
    path: '/:all(.*)',
    name: '404',
    meta: { title: '404', i18n: 'menus.404Demo' },
    component: () => import('@/views/notFind.vue'),
  },
];
// 测试环境使用
const baseUrl = import.meta.env.VITE_ROUTER_BASE;
console.log('🚀 ~ baseUrl:', baseUrl);

const router = createRouter({
  history: createWebHistory(baseUrl ?? ''),
  routes,
});

const UPDATE_RELOAD_KEY = '__chunk_reload_attempted__';
const hasReloaded = () => {
  try {
    return sessionStorage.getItem(UPDATE_RELOAD_KEY) === '1';
  } catch {
    return false;
  }
};
const markReloaded = () => {
  try {
    sessionStorage.setItem(UPDATE_RELOAD_KEY, '1');
  } catch {
    // ignore storage errors
  }
};
// 显示更新提示的通用函数
const showUpdateDialog = () => {
  console.log('🔄 触发版本更新提示');
  const alreadyReloaded = hasReloaded();

  if (alreadyReloaded) {
    showDialog({
      title: '版本更新',
      message: '检测到资源更新失败，请点击刷新或稍后重试',
      showConfirmButton: true,
      confirmButtonText: '刷新',
      closeOnClickOverlay: false,
    }).then(() => {
      console.log('🔄 用户确认刷新');
      window.location.reload();
    });
  } else {
    showDialog({
      title: '版本更新',
      message: '检测到新版本，即将自动更新',
      showConfirmButton: false,
      closeOnClickOverlay: false,
    });
  }

  if (!alreadyReloaded) {
    markReloaded();
    setTimeout(() => {
      console.log('🔄 开始自动刷新页面');
      window.location.reload();
    }, 2000);
  }
};

// 方案1: 捕获路由错误，检测版本更新
router.onError((error) => {
  console.error('❌ 路由错误捕获:', error);
  console.log('错误信息:', error.message);
  console.log('错误堆栈:', error.stack);

  const message = error.message;

  // 匹配多种可能的动态导入失败错误（包括微信浏览器）
  const isChunkLoadError =
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('Importing a module script failed') ||
    message.includes('fetch') ||
    message.includes('import') ||
    message.includes('load') ||
    /chunk.*fail/i.test(message) ||
    /module.*fail/i.test(message);
  console.log('是否为chunk加载错误:', isChunkLoadError);
  if (isChunkLoadError) {
    showUpdateDialog();
  }
});

// 路由守卫(由于刚进来就微信自动登录，所以不判断token了)
router.beforeEach(async (to, _from, next) => {
  // 根据是否为助教端选择对应的用户状态管理
  const userStore = teach ? useTeachUserStore() : useUserStore();
  const routeCacheStore = useRouteCacheStore();
  const authStore = useAuthStore();
  const userInfo = computed(() => userStore.userInfo);

  // 检查是否是微信授权回调（包含code和state=STATE参数）
  // 直接从路由查询参数中检测，避免与window.location不同步
  const code = to.query.code as string;
  const state = to.query.state as string;

  console.log('微信授权回调参数:', { code, state });

  if (code && state === 'STATE') {
    console.log('检测到微信授权回调，code:', code);

    // 使用auth store保存code
    authStore.setCode(code);
    localStorage.setItem('persist_code', code);

    // 构建清除code和state参数后的新查询对象
    const cleanQuery = { ...to.query };
    delete cleanQuery.code;
    delete cleanQuery.state;

    console.log('=== 微信授权回调参数恢复 ===');
    console.log('1. 原始to.query:', JSON.stringify(to.query));

    // 恢复保存的查询参数
    try {
      const savedParams = localStorage.getItem('savedQueryParams');
      console.log('2. localStorage中的savedQueryParams:', savedParams);
      if (savedParams) {
        const params = JSON.parse(savedParams);
        console.log('3. 解析后的params:', JSON.stringify(params));
        Object.assign(cleanQuery, params);
        console.log('4. 合并后的cleanQuery:', JSON.stringify(cleanQuery));
        localStorage.removeItem('savedQueryParams');
      }
    } catch (e) {
      console.error('恢复查询参数失败:', e);
    }

    cleanQuery.rn = Date.now().toString();
    console.log('5. 最终cleanQuery:', JSON.stringify(cleanQuery));

    console.log('已保存授权码，清除URL参数后重定向到:', to.path, cleanQuery);
    // 如果是助教并且是苹果系统走下面逻辑
    if (teach && !isIOS()) {
      // 开发者工具
      if (document.referrer && document.referrer.includes('open.weixin.qq.com')) {
        window.history.go(-2);
      } else {
        next({ path: to.path, query: cleanQuery, replace: true });
        // window.history.go(-1);
      }

      return;
    }
    // 使用router.replace重定向到清理后的路径，避免URL污染
    next({ path: to.path, query: cleanQuery, replace: true });

    return;
  }

  // 添加路由到缓存
  routeCacheStore.addRoute(to as EnhancedRouteLocation);

  // 设置页面标题
  if (to.meta?.title) {
    document.title = to.meta.title ? `${to.meta.title} ` : '助教预约';
  }
  // 以下路径不需要检测，登录注册页面、登录、注册、缺省页
  console.log('当前路径', to.path, '忽略检测的路径列表', teachRouteWhiteList);
  if (teach && !teachRouteWhiteList.includes(to.path)) {
    console.log('助教端访问，检查登录状态', userInfo.value);
    // 没有手机号直接跳登录注册页面(一般只会走到这里，因为如果是在审核中和审核不通过是拿不到用户信息的)
    if (!userInfo.value.phone) {
      console.log('助教端未登录，跳转登录注册页面');
      next({ path: '/login-register', query: to.query });
      return;
    }
  }
  console.log('路由守卫检查完毕，允许访问:', to.path);
  next();
});

export default router;
